(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7136],{

/***/ 31785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42990);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1922);
/* harmony import */ var _AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16130);
/* harmony import */ var _AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var AdminOnlyIndicator = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx("admin-only-indicator"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx("admin-only-indicator__icon"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__.I, {
                    name: "eye"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx("admin-only-indicator__message"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: t("components-adminOnlyIndicator-info_message", "Only admins can see this")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdminOnlyIndicator);


/***/ }),

/***/ 6106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CommunityChecklist_CommunityChecklist; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./components/InfoCard/index.ts + 3 modules
var InfoCard = __webpack_require__(4069);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./components/AdminOnlyIndicator/index.tsx
var AdminOnlyIndicator = __webpack_require__(31785);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./components/CommunityChecklist/CommunityChecklist.module.scss
var CommunityChecklist_module = __webpack_require__(63047);
var CommunityChecklist_module_default = /*#__PURE__*/__webpack_require__.n(CommunityChecklist_module);
;// CONCATENATED MODULE: ./components/CommunityChecklist/CommunityChecklist.tsx














var cx = bind_default().bind((CommunityChecklist_module_default()));
var CommunityChecklist = function() {
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, trackEvent = ref.trackEvent;
    var t = (0,es/* useTranslation */.$G)().t;
    var trackNavigationEvent = function(event) {
        trackEvent(event, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "CommunityChecklist"));
    };
    var publishOpenModal = function() {
        trackEvent(trackingEvents/* default.POST_MODAL_OPENED */.ZP.POST_MODAL_OPENED, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "CommunityChecklist"));
        PubSub.publish(eventNames/* eventNames.OPEN_POST_MODAL */.S.OPEN_POST_MODAL);
    };
    var checklistOption = function(option) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
            appearance: "link",
            className: cx("community-checklist-option__button"),
            "data-qa": option.dataQA,
            href: option.link,
            onClick: option.onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: cx("community-checklist-option__container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: cx("community-checklist-option__icon-container"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                            className: cx("community-checklist-option__icon"),
                            name: option.icon
                        })
                    }),
                    option.text
                ]
            })
        }, option.key);
    };
    var communityChecklistOptions = [
        {
            text: t("components-communityChecklist-set_up_profile", "Set up your profile"),
            icon: "smiley-face",
            link: routerHelpers/* routes.myAccount */._j.myAccount,
            onClick: function() {
                return trackNavigationEvent(trackingEvents/* default.GO_TO_PROFILE */.ZP.GO_TO_PROFILE);
            },
            dataQA: "community-checklist-option__button-profile",
            key: "components-communityChecklist-set_up_profile"
        },
        {
            text: t("components-communityChecklist-welcome_post", "Publish a welcome post"),
            icon: "page-new",
            link: undefined,
            onClick: publishOpenModal,
            dataQA: "community-checklist-option__button-welcome-post",
            key: "components-communityChecklist-welcome_post"
        },
        {
            text: t("components-communityChecklist-customize_community", "Customize community"),
            icon: "cog",
            link: (0,routerHelpers/* getSettingsUrl */.ro)(community.id),
            onClick: function() {
                return trackNavigationEvent(trackingEvents/* default.GO_TO_CUSTOMIZE_COMMUNITY */.ZP.GO_TO_CUSTOMIZE_COMMUNITY);
            },
            dataQA: "community-checklist-option__button-customize-community",
            key: "components-communityChecklist-customize_community"
        },
        {
            text: t("components-communityChecklist-set_community_access", "Set community access"),
            icon: "user-logout",
            link: (0,routerHelpers/* getSettingsUrl */.ro)(community.id),
            onClick: function() {
                return trackNavigationEvent(trackingEvents/* default.GO_TO_SET_ACCESS */.ZP.GO_TO_SET_ACCESS);
            },
            dataQA: "community-checklist-option__button-set-access",
            key: "components-communityChecklist-set_community_access"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoCard/* default */.Z, {
        dataQA: "launch-community-checklist",
        title: t("components-communityChecklist_title", "Launch your Community"),
        isCompact: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("components-communityChecklist-explanation_text", "Follow these steps to set up and launch your community.")
            }),
            communityChecklistOptions.map(function(option) {
                return checklistOption(option);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                appearance: "default",
                ariaLabel: t("components-communityChecklist-publish_button", "Publish Community"),
                className: cx("community-checklist-publish__button"),
                color: community.primaryColor,
                "data-qa": "community-checklist-option__button-publish",
                href: (0,routerHelpers/* getPublishUrl */.ZN)(community.id),
                onClick: function() {
                    return trackNavigationEvent(trackingEvents/* default.GO_TO_PUBLISH_COMMUNITY */.ZP.GO_TO_PUBLISH_COMMUNITY);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: cx("community-checklist-option__container"),
                    children: [
                        t("components-communityChecklist-publish_button", "Publish Community"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                            className: cx("community-checklist-publish__icon"),
                            name: "arrow-right"
                        })
                    ]
                })
            }, "components-communityChecklist-publish_button"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminOnlyIndicator/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var CommunityChecklist_CommunityChecklist = (CommunityChecklist);

;// CONCATENATED MODULE: ./components/CommunityChecklist/index.ts



/***/ }),

/***/ 11357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9973);




var CommunityHeader = function(param) {
    var pageTitle = param.pageTitle;
    var community = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__/* .useCommunityContext */ .v1)().community;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
            children: [
                pageTitle,
                " | ",
                community.name
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommunityHeader);


/***/ }),

/***/ 43718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ EventPreviewProvider; },
/* harmony export */   "Qq": function() { return /* binding */ useEventPreviewContext; }
/* harmony export */ });
/* unused harmony export EventPreviewContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59830);



var EventPreviewContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
var useEventPreviewContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(EventPreviewContext);
};
var EventPreviewProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .EVENT_IMAGE_PLACEHOLDER */ .dm), imageUrl = ref[0], setImageUrl = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), altText = ref1[0], setAltText = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), startTime = ref3[0], setStartTime = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), endTime = ref4[0], setEndTime = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), timezone = ref5[0], setTimezone = ref5[1];
    var clearPreview = function() {
        setImageUrl(utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .EVENT_IMAGE_PLACEHOLDER */ .dm);
        setAltText("");
        setTitle("");
        setStartTime("");
        setEndTime("");
        setTimezone("");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EventPreviewContext.Provider, {
        value: {
            imageUrl: imageUrl,
            setImageUrl: setImageUrl,
            altText: altText,
            setAltText: setAltText,
            title: title,
            setTitle: setTitle,
            startTime: startTime,
            setStartTime: setStartTime,
            endTime: endTime,
            setEndTime: setEndTime,
            timezone: timezone,
            setTimezone: setTimezone,
            clearPreview: clearPreview
        },
        children: children
    });
};



/***/ }),

/***/ 24159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1922);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90923);
/* harmony import */ var toga__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5370);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9973);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17981);
/* harmony import */ var utils_userHelpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73652);
/* harmony import */ var utils_routerHelpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4154);
/* harmony import */ var constants_featureFlags__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46139);
/* harmony import */ var components_Events_hooks_useEventInterest__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65699);
/* harmony import */ var components_SiteFeaturesContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40670);
/* harmony import */ var _EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64324);
/* harmony import */ var _EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14__);
















var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()));
var EventCard = function(param) {
    var id = param.id, title = param.title, imageUrl = param.imageUrl, imageAltText = param.imageAltText, startTime = param.startTime, endTime = param.endTime, timezone = param.timezone, isPreview = param.isPreview, interestedUserCount = param.interestedUserCount, isInterested = param.isInterested;
    var ref;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var ref1 = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_6__/* .useCommunityContext */ .v1)(), currentUser = ref1.currentUser, community = ref1.community, featureFlags = ref1.featureFlags;
    var siteFeatures = (0,components_SiteFeaturesContext__WEBPACK_IMPORTED_MODULE_13__/* .useSiteFeaturesContext */ .Er)().siteFeatures;
    var eventNotificationsEnabled = siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref = siteFeatures.communityEventNotifications) === null || ref === void 0 ? void 0 : ref.isEnabled;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref2 = (0,components_Events_hooks_useEventInterest__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(id), addInterest = ref2.addInterest, removeInterest = ref2.removeInterest, loading = ref2.loading;
    var rsvpEnabled = featureFlags[constants_featureFlags__WEBPACK_IMPORTED_MODULE_11__/* .features.COMMUNITIES_EVENTS_RSVP */ .R.COMMUNITIES_EVENTS_RSVP];
    var formattedDate = (0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .localeEventsDate */ .U0)(startTime, currentUser.locale, timezone);
    var getBadgeText = function() {
        if ((0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventLive */ .MF)(startTime, endTime)) return t("components-events-eventCard-live", "Live");
        if ((0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventStartingSoon */ .HE)(startTime, 15)) return t("components-events-eventCard-starting_soon", "Starting soon");
        return "";
    };
    var actions = [];
    var statusList = [];
    var isPastEvent = new Date() > new Date(endTime);
    if (rsvpEnabled && eventNotificationsEnabled && id) {
        if ((0,utils_userHelpers__WEBPACK_IMPORTED_MODULE_9__/* .isAdmin */ .GJ)(currentUser)) {
            actions.push({
                name: "Edit",
                text: t("common-EDIT", "EDIT"),
                onClick: function() {
                    (0,utils_routerHelpers__WEBPACK_IMPORTED_MODULE_10__/* .goToEditEvent */ .zf)(router, id, community.id);
                }
            });
            if (interestedUserCount) {
                statusList.push(t("components-events-interested_total", "{{total}} Interested", {
                    total: interestedUserCount
                }));
            }
        } else if (!isPastEvent) {
            if (isInterested) {
                // Interested Student
                actions.push({
                    name: "Remove Interest",
                    iconLeft: "minus",
                    text: t("components-events-eventCard-REMOVE_INTEREST", "REMOVE INTEREST"),
                    onClick: function() {
                        removeInterest();
                    }
                });
                if (interestedUserCount === 1) {
                    // There is only one interested student and it is you
                    statusList.push({
                        text: t("components-events-interested", "Interested"),
                        type: "active"
                    });
                } else if (interestedUserCount) {
                    // There are many interested including you
                    statusList.push({
                        text: t("components-events-you_and_others_interested", "You & {{total}} Interested", {
                            total: interestedUserCount - 1
                        }),
                        type: "active"
                    });
                }
            } else {
                // Student and they are not interested
                actions.push({
                    name: "Express Interest",
                    iconLeft: "plus",
                    text: t("components-events-eventCard-INTERESTED", "INTERESTED"),
                    onClick: function() {
                        addInterest();
                    }
                });
                if (interestedUserCount) {
                    statusList.push({
                        text: t("components-events-interested_total", "{{total}} Interested", {
                            total: interestedUserCount
                        }),
                        type: "inactive"
                    });
                }
            }
        }
    }
    var showFooter = !!actions.length;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(toga__WEBPACK_IMPORTED_MODULE_5__/* .Card */ .Zb, {
        badgeText: isPreview ? "" : getBadgeText(),
        badgeType: (0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventLive */ .MF)(startTime, endTime) ? "danger" : "success",
        caption: formattedDate,
        className: cx("event-card"),
        footerActions: showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_15__.I, {
            actions: actions,
            ariaLabel: t("components-events-eventCard-dropdown_aria_label", "Event Card Dropdown"),
            buttonAppearance: "knockout"
        }),
        image: imageUrl || utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .EVENT_IMAGE_PLACEHOLDER */ .dm,
        imageAlt: imageAltText || "",
        isDisabled: loading,
        name: title,
        statusList: statusList,
        invertedCaption: true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventCard);


/***/ }),

/***/ 4069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InfoCard_InfoCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./components/Card/Card.module.scss
var Card_module = __webpack_require__(25079);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ./components/Card/Card.tsx




var cx = bind_default().bind((Card_module_default()));
var Card = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx("card"),
        children: children
    });
};
/* harmony default export */ var Card_Card = (Card);

;// CONCATENATED MODULE: ./components/Card/index.ts


// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(6482);
// EXTERNAL MODULE: ./components/InfoCard/InfoCard.module.scss
var InfoCard_module = __webpack_require__(4856);
var InfoCard_module_default = /*#__PURE__*/__webpack_require__.n(InfoCard_module);
;// CONCATENATED MODULE: ./components/InfoCard/InfoCard.tsx








var InfoCard_cx = bind_default().bind((InfoCard_module_default()));
var InfoCard = function(param) {
    var isDismissable = param.isDismissable, title = param.title, isCompact = param.isCompact, children = param.children, localStorageKey = param.localStorageKey, dataQA = param.dataQA, onClose = param.onClose, wrapper = param.wrapper;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,useLocalStorage/* default */.Z)(localStorageKey || ""), isSaved = ref.isSaved, saveKeyInLocalStorage = ref.saveKeyInLocalStorage;
    if (isDismissable && isSaved) return null;
    // If no localStorageKey is provided, then we know
    // that the component should be shown back if the user
    // refreshes/goes away and comes back to the page where
    // the section shown.
    var handleHideSection = function() {
        if (localStorageKey) saveKeyInLocalStorage(true);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var dismissButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
        appearance: "utility",
        className: InfoCard_cx("info-card__dismiss-button"),
        name: "x-dismiss",
        title: t("common-dismiss-empty-state", "Dismiss the {{title}} section", {
            title: title
        }),
        onClick: handleHideSection
    });
    var Wrapper = wrapper || Card_Card;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: InfoCard_cx("info-card", {
                "info-card--compact": isCompact
            }),
            "data-qa": dataQA,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: InfoCard_cx("info-card__dismiss-wrapper"),
                    children: isDismissable && dismissButton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: InfoCard_cx("info-card__header", {
                        "info-card__header--dismissable": isDismissable
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: InfoCard_cx("info-card__title", {
                            "info-card__title--compact": isCompact
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var InfoCard_InfoCard = (InfoCard);

;// CONCATENATED MODULE: ./components/InfoCard/index.ts



/***/ }),

/***/ 96748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ getLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./components/Layouts/SiteLayout/index.ts + 28 modules
var SiteLayout = __webpack_require__(76831);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./helpers/styleHelpers.js
var styleHelpers = __webpack_require__(89804);
// EXTERNAL MODULE: ./components/SpaceDetails/index.ts + 2 modules
var SpaceDetails = __webpack_require__(19024);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/SiteFeaturesContext/index.ts + 2 modules
var SiteFeaturesContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/Contexts/EventPreview/EventPreviewContext.tsx
var EventPreviewContext = __webpack_require__(43718);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./components/CommunityActions/index.ts + 36 modules
var CommunityActions = __webpack_require__(47395);
// EXTERNAL MODULE: ./components/CommunityBrandingBadge/CommunityBrandingBadge.module.scss
var CommunityBrandingBadge_module = __webpack_require__(36229);
var CommunityBrandingBadge_module_default = /*#__PURE__*/__webpack_require__.n(CommunityBrandingBadge_module);
;// CONCATENATED MODULE: ./components/CommunityBrandingBadge/CommunityBrandingBadge.tsx





var cx = bind_default().bind((CommunityBrandingBadge_module_default()));
var CommunityBrandingBadge = function(param) {
    var site = param.site;
    if (site.whiteLabellingActivated) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx("community-branding-badge"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: cx("community-branding-badge__link"),
            href: "https://www.thinkific.com/?ref=".concat(site.subdomain, "-community-poweredby"),
            rel: "noopener",
            target: "_blank",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: constants/* POWERED_BY_THINKIFIC_ALT */.Bl,
                className: cx("community-branding-badge__svg"),
                src: constants/* POWERED_BY_THINKIFIC */.AS
            })
        })
    });
};


;// CONCATENATED MODULE: ./components/CommunityBrandingBadge/index.ts


// EXTERNAL MODULE: ./components/CourseCard/CourseDetails.tsx + 1 modules
var CourseDetails = __webpack_require__(80948);
// EXTERNAL MODULE: ./components/CommunityChecklist/index.ts + 1 modules
var CommunityChecklist = __webpack_require__(6106);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/P-3714214d.js
var P_3714214d = __webpack_require__(61783);
// EXTERNAL MODULE: ./schema/Post/queries.ts
var queries = __webpack_require__(95313);
// EXTERNAL MODULE: ./schema/globalTypes.ts
var globalTypes = __webpack_require__(5527);
// EXTERNAL MODULE: ./helpers/postHelpers.ts
var postHelpers = __webpack_require__(68642);
// EXTERNAL MODULE: ./components/VisibilityCloak/VisibilityCloak.tsx
var VisibilityCloak = __webpack_require__(37510);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./helpers/interactions/index.ts
var interactions = __webpack_require__(56427);
// EXTERNAL MODULE: ./components/TrendingPosts/TrendingPost/TrendingPost.module.scss
var TrendingPost_module = __webpack_require__(77515);
var TrendingPost_module_default = /*#__PURE__*/__webpack_require__.n(TrendingPost_module);
;// CONCATENATED MODULE: ./components/TrendingPosts/TrendingPost/TrendingPost.tsx














var TrendingPost_cx = bind_default().bind((TrendingPost_module_default()));
var TrendingPost = function(param) {
    var author = param.author, commentCount = param.commentCount, title = param.title, id = param.id;
    var router = (0,next_router.useRouter)();
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, trackEvent = ref.trackEvent;
    var handlePostClick = function() {
        (0,routerHelpers/* goToPostPage */.YY)(router, community.id, id);
        trackEvent(trackingEvents/* default.TRENDING_POST_CLICKED */.ZP.TRENDING_POST_CLICKED, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": t("shared-read_full_post", "Read full post: {{title}}", {
            title: title
        }),
        className: TrendingPost_cx("trending-post__item"),
        "data-qa": "trending-post__item"
    }, (0,interactions/* a11yOnClick */.Z)(function() {
        return handlePostClick();
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
                title: author === null || author === void 0 ? void 0 : author.fullName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                    avatarUrl: author === null || author === void 0 ? void 0 : author.avatarUrl,
                    className: TrendingPost_cx("trending-post__avatar"),
                    size: "xs",
                    srcSet: "".concat(author === null || author === void 0 ? void 0 : author.avatarUrl, "?width=32 1x, ").concat(author === null || author === void 0 ? void 0 : author.avatarUrl, "?width=32&dpr=2 2x, ").concat(author === null || author === void 0 ? void 0 : author.avatarUrl, "?width=32&dpr=3 3x"),
                    userId: (author === null || author === void 0 ? void 0 : author.id) || "",
                    username: (author === null || author === void 0 ? void 0 : author.fullName) || ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: TrendingPost_cx("trending-post__item__post"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: TrendingPost_cx("trending-post__item__post--title"),
                        "data-qa": "trending-post-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: TrendingPost_cx("trending-post__item__post--subtitle"),
                        "data-qa": "trending-post-comment",
                        children: t("shared-comment_amount", "{{count}} comment", {
                            count: commentCount
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var TrendingPost_TrendingPost = (TrendingPost);

// EXTERNAL MODULE: ./koba/components/SkeletonPost/index.ts
var SkeletonPost = __webpack_require__(13925);
// EXTERNAL MODULE: ./components/TrendingPosts/TrendingPostsSkeleton/TrendingPostsSkeleton.module.scss
var TrendingPostsSkeleton_module = __webpack_require__(13995);
var TrendingPostsSkeleton_module_default = /*#__PURE__*/__webpack_require__.n(TrendingPostsSkeleton_module);
;// CONCATENATED MODULE: ./components/TrendingPosts/TrendingPostsSkeleton/TrendingPostsSkeleton.tsx





var TrendingPostsSkeleton_cx = bind_default().bind((TrendingPostsSkeleton_module_default()));
var TrendingPostSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: TrendingPostsSkeleton_cx("trending-post-skeleton"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: TrendingPostsSkeleton_cx("trending-post-skeleton__avatar")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: TrendingPostsSkeleton_cx("trending-post-skeleton__body"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                        width: "80px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                        width: "160px"
                    })
                ]
            })
        ]
    });
};
var TrendingPostsSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: TrendingPostsSkeleton_cx("trending-posts-skeleton__container"),
        "data-qa": "trending-posts-skeleton",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                height: "16px",
                width: "60%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: TrendingPostsSkeleton_cx("trending-posts-skeleton__body"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingPostSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingPostSkeleton, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var TrendingPostsSkeleton_TrendingPostsSkeleton = (TrendingPostsSkeleton);

// EXTERNAL MODULE: ./components/InfoCard/index.ts + 3 modules
var InfoCard = __webpack_require__(4069);
// EXTERNAL MODULE: ./components/Image/index.ts + 1 modules
var Image = __webpack_require__(82513);
// EXTERNAL MODULE: ./components/AdminOnlyIndicator/index.tsx
var AdminOnlyIndicator = __webpack_require__(31785);
// EXTERNAL MODULE: ./components/TrendingPosts/ExplanationCard/ExplanationCard.module.scss
var ExplanationCard_module = __webpack_require__(3334);
var ExplanationCard_module_default = /*#__PURE__*/__webpack_require__.n(ExplanationCard_module);
;// CONCATENATED MODULE: ./components/TrendingPosts/ExplanationCard/ExplanationCard.tsx









var ExplanationCard_cx = bind_default().bind((ExplanationCard_module_default()));
var ExplanationCard = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: ExplanationCard_cx("explanation-card"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoCard/* default */.Z, {
            dataQA: "trending-posts-explanation-card",
            localStorageKey: "hideTrendingPostsEmptyState",
            title: t("components-trendingPosts_title", "Trending posts"),
            isCompact: true,
            isDismissable: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("components-trendingPosts-explanation_text", "Posts with the most engagement will show up here, driving even more visibility and momentum.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    children: t("common_PREVIEW", "PREVIEW")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    height: 582,
                    src: constants/* TRENDING_POSTS_IMAGE */.jo,
                    width: 690
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminOnlyIndicator/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var ExplanationCard_ExplanationCard = (ExplanationCard);

// EXTERNAL MODULE: ./components/TrendingPosts/TrendingPosts.module.scss
var TrendingPosts_module = __webpack_require__(59432);
var TrendingPosts_module_default = /*#__PURE__*/__webpack_require__.n(TrendingPosts_module);
;// CONCATENATED MODULE: ./components/TrendingPosts/TrendingPosts.tsx
















var TrendingPosts_cx = bind_default().bind((TrendingPosts_module_default()));
var TrendingPosts = function() {
    var ref, ref1;
    var t = (0,es/* useTranslation */.$G)().t;
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    var ref2 = (0,useQuery/* useQuery */.a)(queries/* POST_LIST_QUERY */.c, {
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true,
        variables: {
            communityId: community.id,
            numOfPosts: constants/* TRENDING_POSTS_MAX */.k5,
            postOrderField: globalTypes/* PostOrderField.TRENDING_SCORE */.d3.TRENDING_SCORE,
            filter: {
                trending: true
            },
            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
        }
    }), loading = ref2.loading, data = ref2.data;
    var posts = (data === null || data === void 0 ? void 0 : (ref = data.community) === null || ref === void 0 ? void 0 : (ref1 = ref.posts) === null || ref1 === void 0 ? void 0 : ref1.edges) || [];
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
            admins: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingPostsSkeleton_TrendingPostsSkeleton, {})
        });
    }
    if (posts.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
            admins: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExplanationCard_ExplanationCard, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: TrendingPosts_cx("trending-posts"),
        "data-qa": "trending-posts",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P_3714214d.P, {
                className: TrendingPosts_cx("trending-posts__title"),
                children: t("components-trendingPosts_title", "Trending posts")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: TrendingPosts_cx("trending-posts__list"),
                children: posts.map(function(edge) {
                    var post = edge === null || edge === void 0 ? void 0 : edge.node;
                    if (!post) return null;
                    var totalCommentCount = (0,postHelpers/* getTotalNumberOfReplies */.E)(post);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingPost_TrendingPost, {
                        author: post === null || post === void 0 ? void 0 : post.user,
                        commentCount: totalCommentCount,
                        id: post.id,
                        title: post.title || ""
                    }, post.id);
                })
            })
        ]
    });
};
/* harmony default export */ var TrendingPosts_TrendingPosts = (TrendingPosts);

// EXTERNAL MODULE: ./components/Opacity/Opacity.tsx
var Opacity = __webpack_require__(21349);
// EXTERNAL MODULE: ./components/Events/components/EventCard/EventCard.tsx
var EventCard = __webpack_require__(24159);
;// CONCATENATED MODULE: ./components/Events/components/EventPreviewCard/EventPreviewCard.tsx






var EventPreviewCard = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,EventPreviewContext/* useEventPreviewContext */.Qq)(), imageUrl = ref.imageUrl, altText = ref.altText, title = ref.title, startTime = ref.startTime, endTime = ref.endTime, timezone = ref.timezone;
    var titlePlaceholder = t("components-forms-weekly_check_in_placeholder", "eg. Weekly Check-in, Q&A...");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Opacity/* default */.Z, {
        value: 0.6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard/* default */.Z, {
            endTime: endTime,
            imageAltText: altText,
            imageUrl: imageUrl,
            startTime: startTime,
            timezone: timezone || undefined,
            title: title || titlePlaceholder,
            isPreview: true
        })
    });
};
/* harmony default export */ var EventPreviewCard_EventPreviewCard = (EventPreviewCard);

// EXTERNAL MODULE: ./pages/[communityId]/index.module.scss
var index_module = __webpack_require__(53831);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/Layouts/MainLayout/MainLayout.tsx























var MainLayout_cx = bind_default().bind((index_module_default()));
var MainLayout = function(param) {
    var children = param.children;
    var ref;
    var t = (0,es/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var ref1 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref1.community, site = ref1.site, featureFlags = ref1.featureFlags;
    var exceededPlanSpaces = (0,SiteFeaturesContext/* useSiteFeaturesContext */.Er)().exceededPlanSpaces;
    var isCoursesToCommunitiesEnabled = featureFlags[constants_featureFlags/* features.COURSES_TO_COMMUNITIES */.R.COURSES_TO_COMMUNITIES];
    var isTrendingPostsEnabled = featureFlags[constants_featureFlags/* features.COMMUNITIES_TRENDING_POSTS */.R.COMMUNITIES_TRENDING_POSTS];
    var isCommunitiesAsAProductEnabled = featureFlags[constants_featureFlags/* features.COMMUNITIES_AS_A_PRODUCT */.R.COMMUNITIES_AS_A_PRODUCT];
    (0,react.useEffect)(function() {
        (0,styleHelpers/* setGlobalCSSVariables */.S)(community.primaryColor);
    }, [
        community
    ]);
    var spaceDetailPages = [
        routerHelpers/* pathnames.spaces.space */.$O.spaces.space,
        routerHelpers/* pathnames.spaces.new */.$O.spaces["new"],
        routerHelpers/* pathnames.spaces.edit */.$O.spaces.edit, 
    ];
    var courseCardPages = [
        routerHelpers/* pathnames.spaces.space */.$O.spaces.space,
        routerHelpers/* pathnames.spaces.new */.$O.spaces["new"],
        routerHelpers/* pathnames.spaces.edit */.$O.spaces.edit, 
    ];
    var eventCardPages = [
        routerHelpers/* pathnames.events.new */.$O.events["new"],
        routerHelpers/* pathnames.events.edit */.$O.events.edit
    ];
    var isHomePage = pathname === routerHelpers/* pathnames.home */.$O.home;
    var isNewSpacePage = pathname === routerHelpers/* pathnames.spaces.new */.$O.spaces["new"];
    var showSpaceDetails = spaceDetailPages.includes(pathname);
    var includeCourseCard = courseCardPages.includes(pathname);
    var includeEventCard = eventCardPages.includes(pathname);
    var showRightColumn = width >= constants/* SCREEN_LG */.k4;
    var spaceId = (ref = router.query) === null || ref === void 0 ? void 0 : ref.spaceId;
    var shouldShowCommunitiesChecklist = !community.published && isHomePage && isCommunitiesAsAProductEnabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: MainLayout_cx("community-wrapper", "is-spaces-in-communities-enabled"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPreviewContext/* EventPreviewProvider */.CW, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityActions/* default */.Z, {
                    className: MainLayout_cx("desktop-navigation")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: MainLayout_cx("main-content"),
                    "data-qa": "main-content",
                    children: children
                }),
                showRightColumn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    "aria-label": t("Extra information"),
                    className: MainLayout_cx("right-content"),
                    "data-qa": "right-content",
                    children: [
                        showSpaceDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceDetails/* SpaceDetails */.F, {
                            className: MainLayout_cx("desktop-navigation"),
                            communityId: community.id,
                            spaceId: spaceId
                        }),
                        isCoursesToCommunitiesEnabled && includeCourseCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                            hide: isNewSpacePage && exceededPlanSpaces,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseDetails/* default */.Z, {})
                        }),
                        includeEventCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPreviewCard_EventPreviewCard, {}),
                        community.published && isTrendingPostsEnabled && isHomePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingPosts_TrendingPosts, {}),
                        shouldShowCommunitiesChecklist && /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                            admins: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityChecklist/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityBrandingBadge, {
                            site: site
                        })
                    ]
                })
            ]
        })
    });
};
var getLayout = function(page) {
    return (0,SiteLayout/* getLayout */.G)(/*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout, {
        children: page
    }));
};
/* harmony default export */ var MainLayout_MainLayout = ((/* unused pure expression or super */ null && (MainLayout)));

;// CONCATENATED MODULE: ./components/Layouts/MainLayout/index.ts



/***/ }),

/***/ 68642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getTotalNumberOfReplies; },
/* harmony export */   "O": function() { return /* binding */ sanitizeAttachments; }
/* harmony export */ });
var sanitizeAttachments = function(postAttachment) {
    if (!postAttachment) return undefined;
    var safeFieldNames = [
        "attachmentType",
        "attachmentUrl",
        "fileName",
        "fileSizeInBytes",
        "s3Bucket",
        "s3Key",
        "filestackId",
        "altText", 
    ];
    var attachment = {};
    // eslint-disable-next-line no-restricted-syntax, no-unused-vars
    for(var key in postAttachment){
        if (safeFieldNames.includes(key)) {
            attachment[key] = postAttachment[key];
        }
    }
    // @ts-ignore
    return attachment;
};
var getTotalNumberOfReplies = function(post) {
    var ref;
    if (!post) return 0;
    var replies = post.replies;
    var result = (replies === null || replies === void 0 ? void 0 : (ref = replies.nodes) === null || ref === void 0 ? void 0 : ref.reduce(function(total, reply) {
        var ref;
        return total + ((reply === null || reply === void 0 ? void 0 : (ref = reply.replies) === null || ref === void 0 ? void 0 : ref.totalCount) || 0);
    }, replies.totalCount)) || 0;
    return result || 0;
};


/***/ }),

/***/ 6482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useLocalStorage = function(localStorageKey) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!localStorage.getItem(localStorageKey)), isSaved = ref[0], setIsSaved = ref[1];
    var getKeyFromLocalStorage = function() {
        var value = localStorage.getItem(localStorageKey);
        if (value) return JSON.parse(value);
        return null;
    };
    var saveKeyInLocalStorage = function(value) {
        try {
            localStorage.setItem(localStorageKey, JSON.stringify(value));
            setIsSaved(true);
        } catch (e) {
            setIsSaved(false);
        }
    };
    var removeKeyFromLocalStorage = function() {
        try {
            localStorage.removeItem(localStorageKey);
            setIsSaved(false);
        } catch (e) {
            setIsSaved(true);
        }
    };
    return {
        isSaved: isSaved,
        getKeyFromLocalStorage: getKeyFromLocalStorage,
        removeKeyFromLocalStorage: removeKeyFromLocalStorage,
        saveKeyInLocalStorage: saveKeyInLocalStorage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLocalStorage);


/***/ }),

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N9": function() { return /* binding */ OrderDirection; },
/* harmony export */   "d3": function() { return /* binding */ PostOrderField; },
/* harmony export */   "t": function() { return /* binding */ EventStatusTypes; }
/* harmony export */ });
/* unused harmony exports AccountNotificationSlugType, PostAttachmentType, PostReactionType */
var AccountNotificationSlugType;
(function(AccountNotificationSlugType) {
    AccountNotificationSlugType["community_post_reply"] = "community_post_reply";
})(AccountNotificationSlugType || (AccountNotificationSlugType = {}));
var EventStatusTypes;
(function(EventStatusTypes) {
    EventStatusTypes["EXPIRED"] = "EXPIRED";
    EventStatusTypes["UPCOMING"] = "UPCOMING";
})(EventStatusTypes || (EventStatusTypes = {}));
var OrderDirection;
(function(OrderDirection) {
    OrderDirection["ASC"] = "ASC";
    OrderDirection["DESC"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
var PostAttachmentType;
(function(PostAttachmentType) {
    PostAttachmentType["file"] = "file";
    PostAttachmentType["image"] = "image";
    PostAttachmentType["video"] = "video";
})(PostAttachmentType || (PostAttachmentType = {}));
var PostOrderField;
(function(PostOrderField) {
    PostOrderField["CONTENT_NAME"] = "CONTENT_NAME";
    PostOrderField["COURSE_NAME"] = "COURSE_NAME";
    PostOrderField["CREATED_AT"] = "CREATED_AT";
    PostOrderField["LAST_INTERACTION_AT"] = "LAST_INTERACTION_AT";
    PostOrderField["PINNED_AT"] = "PINNED_AT";
    PostOrderField["REPLY_COUNT"] = "REPLY_COUNT";
    PostOrderField["TITLE"] = "TITLE";
    PostOrderField["TRENDING_SCORE"] = "TRENDING_SCORE";
    PostOrderField["UPDATED_AT"] = "UPDATED_AT";
})(PostOrderField || (PostOrderField = {}));
var PostReactionType;
(function(PostReactionType) {
    PostReactionType["like"] = "like";
})(PostReactionType || (PostReactionType = {}));


/***/ }),

/***/ 23077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ togaFooterBlockName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div[class*='footer'] {\n    box-sizing: border-box;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var togaFooterBlockName = "card__footer";
// Toga's react version of this card is missing border-box 🙃
// Card footers render twice as large without it
var wrapped = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_2__.C)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (wrapped);


/***/ }),

/***/ 5370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zb": function() { return /* reexport */ Card/* default */.Z; },
  "JX": function() { return /* reexport */ Col; },
  "W2": function() { return /* reexport */ Container; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Row-ef6c768c.js
var Row_ef6c768c = __webpack_require__(93928);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./toga/Container.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var wrapped = (0,styled_components_browser_esm/* default */.ZP)(Row_ef6c768c.C)(_templateObject());
/* harmony default export */ var Container = (wrapped);

;// CONCATENATED MODULE: ./toga/Col.tsx

function Col_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n"
    ]);
    Col_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Col_wrapped = (0,styled_components_browser_esm/* default */.ZP)(Row_ef6c768c.a)(Col_templateObject());
/* harmony default export */ var Col = (Col_wrapped);

// EXTERNAL MODULE: ./toga/Card.tsx
var Card = __webpack_require__(23077);
;// CONCATENATED MODULE: ./toga/index.ts






/***/ }),

/***/ 16130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"AdminOnlyIndicator_sr-only--mobile__V_O5h","sr-only":"AdminOnlyIndicator_sr-only__qudiG","error-message":"AdminOnlyIndicator_error-message__o6_Mk","form-inline-edit":"AdminOnlyIndicator_form-inline-edit__1rOMu","form-group":"AdminOnlyIndicator_form-group__P_zKT","form-row":"AdminOnlyIndicator_form-row__EzBE2","form-inline":"AdminOnlyIndicator_form-inline__NoKeJ","error":"AdminOnlyIndicator_error__DTNfK","input-group-append":"AdminOnlyIndicator_input-group-append__lhDS3","input-group-currency":"AdminOnlyIndicator_input-group-currency__0zgWg","form-control":"AdminOnlyIndicator_form-control__7nBF_","custom-select":"AdminOnlyIndicator_custom-select__wW7Y_","is-invalid":"AdminOnlyIndicator_is-invalid__xLyF6","is-valid":"AdminOnlyIndicator_is-valid__3bhop","input-group":"AdminOnlyIndicator_input-group__th3eH","input-group-text":"AdminOnlyIndicator_input-group-text__HXMCd","input-group-prepend":"AdminOnlyIndicator_input-group-prepend__xd9BQ","valid-feedback":"AdminOnlyIndicator_valid-feedback__3RqVS","invalid-feedback":"AdminOnlyIndicator_invalid-feedback__vVLXV","form-text":"AdminOnlyIndicator_form-text__EMwMA","label":"AdminOnlyIndicator_label__htcqJ","custom-control":"AdminOnlyIndicator_custom-control__n1VIY","custom-control-label":"AdminOnlyIndicator_custom-control-label__FAv4l","custom-control-label--empty":"AdminOnlyIndicator_custom-control-label--empty__aMFmr","custom-control-input":"AdminOnlyIndicator_custom-control-input__TrqAO","admin-only-indicator":"AdminOnlyIndicator_admin-only-indicator__mMTxj","admin-only-indicator__icon":"AdminOnlyIndicator_admin-only-indicator__icon__Ly9X8","admin-only-indicator__message":"AdminOnlyIndicator_admin-only-indicator__message__c98W5"};

/***/ }),

/***/ 25079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Card_sr-only--mobile__pyBUz","sr-only":"Card_sr-only__SIhMy","error-message":"Card_error-message__yZHay","form-inline-edit":"Card_form-inline-edit__O7lAa","form-group":"Card_form-group__6a19M","form-row":"Card_form-row__GyjgV","form-inline":"Card_form-inline__JC07O","error":"Card_error__AZsoV","input-group-append":"Card_input-group-append__4S9l1","input-group-currency":"Card_input-group-currency__cBLyv","form-control":"Card_form-control__FKUhb","custom-select":"Card_custom-select__wAwyN","is-invalid":"Card_is-invalid__mruvn","is-valid":"Card_is-valid__6nnKW","input-group":"Card_input-group__ZVE3x","input-group-text":"Card_input-group-text__JjRPi","input-group-prepend":"Card_input-group-prepend__4FTVF","valid-feedback":"Card_valid-feedback__LJdLl","invalid-feedback":"Card_invalid-feedback__tZSON","form-text":"Card_form-text__t8Ua4","label":"Card_label__sW6BW","custom-control":"Card_custom-control__r_5XG","custom-control-label":"Card_custom-control-label__g1TZ4","custom-control-label--empty":"Card_custom-control-label--empty__zEhvd","custom-control-input":"Card_custom-control-input__7ePj9","card":"Card_card__pfJM5"};

/***/ }),

/***/ 36229:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"CommunityBrandingBadge_sr-only--mobile__ACkUK","sr-only":"CommunityBrandingBadge_sr-only__08q0i","error-message":"CommunityBrandingBadge_error-message__Fsd3S","form-inline-edit":"CommunityBrandingBadge_form-inline-edit__O6DTs","form-group":"CommunityBrandingBadge_form-group__eEqM9","form-row":"CommunityBrandingBadge_form-row__FJEYN","form-inline":"CommunityBrandingBadge_form-inline__1hlyN","error":"CommunityBrandingBadge_error__Nje6V","input-group-append":"CommunityBrandingBadge_input-group-append___nEA_","input-group-currency":"CommunityBrandingBadge_input-group-currency__n1i90","form-control":"CommunityBrandingBadge_form-control__hLM3c","custom-select":"CommunityBrandingBadge_custom-select__pfO5u","is-invalid":"CommunityBrandingBadge_is-invalid__CNXD0","is-valid":"CommunityBrandingBadge_is-valid__67A0g","input-group":"CommunityBrandingBadge_input-group__dNb5W","input-group-text":"CommunityBrandingBadge_input-group-text__pJ4_k","input-group-prepend":"CommunityBrandingBadge_input-group-prepend__km_1f","valid-feedback":"CommunityBrandingBadge_valid-feedback__mepYk","invalid-feedback":"CommunityBrandingBadge_invalid-feedback__XfH7i","form-text":"CommunityBrandingBadge_form-text__4Mfhr","label":"CommunityBrandingBadge_label__g0voW","custom-control":"CommunityBrandingBadge_custom-control__gZ2Zr","custom-control-label":"CommunityBrandingBadge_custom-control-label__QDUwF","custom-control-label--empty":"CommunityBrandingBadge_custom-control-label--empty__KzQ_H","custom-control-input":"CommunityBrandingBadge_custom-control-input__eb_Qb","community-branding-badge":"CommunityBrandingBadge_community-branding-badge__kyJWx"};

/***/ }),

/***/ 63047:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"community-checklist-option__button":"CommunityChecklist_community-checklist-option__button__wW7Cv","community-checklist-option__container":"CommunityChecklist_community-checklist-option__container__3ZZSp","community-checklist-option__icon-container":"CommunityChecklist_community-checklist-option__icon-container__OTVbZ","community-checklist-option__icon":"CommunityChecklist_community-checklist-option__icon__koOXN","community-checklist-publish__button":"CommunityChecklist_community-checklist-publish__button__CmKdQ"};

/***/ }),

/***/ 64324:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"event-card":"EventCard_event-card__vqeTZ","event-card__title":"EventCard_event-card__title__RgU1t"};

/***/ }),

/***/ 4856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"InfoCard_sr-only--mobile__i601v","sr-only":"InfoCard_sr-only__vL_gU","error-message":"InfoCard_error-message__c92GS","form-inline-edit":"InfoCard_form-inline-edit__TJwoX","form-group":"InfoCard_form-group__keMqm","form-row":"InfoCard_form-row__Qyw2B","form-inline":"InfoCard_form-inline__jbZ4A","error":"InfoCard_error__YP2_l","input-group-append":"InfoCard_input-group-append___EsaJ","input-group-currency":"InfoCard_input-group-currency__aO0mN","form-control":"InfoCard_form-control__sVJ7H","custom-select":"InfoCard_custom-select__Biz3h","is-invalid":"InfoCard_is-invalid__CfhOh","is-valid":"InfoCard_is-valid__dLrJq","input-group":"InfoCard_input-group__xgz5V","input-group-text":"InfoCard_input-group-text__w0tjr","input-group-prepend":"InfoCard_input-group-prepend__K0SE5","valid-feedback":"InfoCard_valid-feedback__fFNYh","invalid-feedback":"InfoCard_invalid-feedback__ej2M8","form-text":"InfoCard_form-text__2NXrk","label":"InfoCard_label__NAJgQ","custom-control":"InfoCard_custom-control___On2o","custom-control-label":"InfoCard_custom-control-label__LEWoW","custom-control-label--empty":"InfoCard_custom-control-label--empty__iiBN4","custom-control-input":"InfoCard_custom-control-input__yntTp","info-card":"InfoCard_info-card__ygNJi","info-card--compact":"InfoCard_info-card--compact__j4bx7","info-card__header":"InfoCard_info-card__header__g_F2p","info-card__header--dismissable":"InfoCard_info-card__header--dismissable__TNoXX","info-card__title":"InfoCard_info-card__title__rzlR1","info-card__title--compact":"InfoCard_info-card__title--compact__rq0x8","info-card__dismiss-wrapper":"InfoCard_info-card__dismiss-wrapper__ESdSm"};

/***/ }),

/***/ 3334:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"explanation-card":"ExplanationCard_explanation-card__X2e0k"};

/***/ }),

/***/ 77515:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"TrendingPost_sr-only--mobile__2A5Vt","sr-only":"TrendingPost_sr-only__dHmhp","error-message":"TrendingPost_error-message__RaIMZ","form-inline-edit":"TrendingPost_form-inline-edit__XCkNw","form-group":"TrendingPost_form-group__uanTE","form-row":"TrendingPost_form-row__ROTGQ","form-inline":"TrendingPost_form-inline__oGWoq","error":"TrendingPost_error__TyB4f","input-group-append":"TrendingPost_input-group-append__s8g0Q","input-group-currency":"TrendingPost_input-group-currency__8Z9qt","form-control":"TrendingPost_form-control__6Gt_i","custom-select":"TrendingPost_custom-select__wTxtr","is-invalid":"TrendingPost_is-invalid__IgAsD","is-valid":"TrendingPost_is-valid__JOEWD","input-group":"TrendingPost_input-group__I1DsZ","input-group-text":"TrendingPost_input-group-text__5i2TO","input-group-prepend":"TrendingPost_input-group-prepend__nioxY","valid-feedback":"TrendingPost_valid-feedback__PJo2w","invalid-feedback":"TrendingPost_invalid-feedback__1uK3r","form-text":"TrendingPost_form-text__Hyj_q","label":"TrendingPost_label__sFFtJ","custom-control":"TrendingPost_custom-control__LPPFR","custom-control-label":"TrendingPost_custom-control-label__6wKKP","custom-control-label--empty":"TrendingPost_custom-control-label--empty__4YncW","custom-control-input":"TrendingPost_custom-control-input__8k2Q_","trending-post__item":"TrendingPost_trending-post__item__TMhQc","trending-post__item__post":"TrendingPost_trending-post__item__post__EmvCH","trending-post__item__post--title":"TrendingPost_trending-post__item__post--title__BGORL","trending-post__item__post--subtitle":"TrendingPost_trending-post__item__post--subtitle__IEuh2"};

/***/ }),

/***/ 59432:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trending-posts":"TrendingPosts_trending-posts__ED7cP","trending-posts__title":"TrendingPosts_trending-posts__title___NgKy","trending-posts__list":"TrendingPosts_trending-posts__list__AHUKX"};

/***/ }),

/***/ 13995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trending-posts-skeleton__container":"TrendingPostsSkeleton_trending-posts-skeleton__container__4PUCX","trending-posts-skeleton__body":"TrendingPostsSkeleton_trending-posts-skeleton__body__jGNh8","trending-post-skeleton":"TrendingPostsSkeleton_trending-post-skeleton__HRgfy","trending-post-skeleton__body":"TrendingPostsSkeleton_trending-post-skeleton__body__iCLLT","trending-post-skeleton__avatar":"TrendingPostsSkeleton_trending-post-skeleton__avatar__uDW60"};

/***/ }),

/***/ 53831:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"_communityId__sr-only--mobile__Bhgf6","sr-only":"_communityId__sr-only__ayf7p","error-message":"_communityId__error-message__s5ZI3","form-inline-edit":"_communityId__form-inline-edit__SklE1","form-group":"_communityId__form-group__OVloT","form-row":"_communityId__form-row__Io5Yz","form-inline":"_communityId__form-inline__fdObK","error":"_communityId__error__4f_ni","input-group-append":"_communityId__input-group-append__vXkaN","input-group-currency":"_communityId__input-group-currency__keVnN","form-control":"_communityId__form-control__d_xOw","custom-select":"_communityId__custom-select__rdlNw","is-invalid":"_communityId__is-invalid__YLhc6","is-valid":"_communityId__is-valid__SYTE4","input-group":"_communityId__input-group__OwfFK","input-group-text":"_communityId__input-group-text__kTPod","input-group-prepend":"_communityId__input-group-prepend__8tgdE","valid-feedback":"_communityId__valid-feedback__H_loW","invalid-feedback":"_communityId__invalid-feedback__zwtiy","form-text":"_communityId__form-text__wXFae","label":"_communityId__label__UvSSx","custom-control":"_communityId__custom-control__BbxWT","custom-control-label":"_communityId__custom-control-label__D6jtC","custom-control-label--empty":"_communityId__custom-control-label--empty__fZ9cm","custom-control-input":"_communityId__custom-control-input__ATPXM","community-wrapper":"_communityId__community-wrapper__IluK9","community-wrapper--post-detail":"_communityId__community-wrapper--post-detail__sVc4V","is-spaces-in-communities-enabled":"_communityId__is-spaces-in-communities-enabled__bkhqd","community-actions":"_communityId__community-actions__maAWb","community-main":"_communityId__community-main__YJK2T","community-main--full-width":"_communityId__community-main--full-width__NSlU7","community-info":"_communityId__community-info__FNR2h","community-info--caption":"_communityId__community-info--caption__s3CCr","post-actions":"_communityId__post-actions__YzTU8","post-actions__button":"_communityId__post-actions__button__hDDrE","post-actions__container":"_communityId__post-actions__container__BsoGT","button__breadcrumb":"_communityId__button__breadcrumb__lMiK1","community-card-wrapper":"_communityId__community-card-wrapper__rJxMN","main-content":"_communityId__main-content__wEhn9","right-content":"_communityId__right-content__m9BwJ"};

/***/ })

}]);